import {useMutation} from '@tanstack/react-query';
import {UpdateBatchProcedureParams} from 'domain/usecases/private/refund/request/update-batch-procedure';
import {updateBatchProcedure} from '../services/updateBatchProcedure';

export const useUpdateBatchProcedureMutation = () =>
	useMutation({
		mutationFn: (params: UpdateBatchProcedureParams) => updateBatchProcedure(params),
		retry: 1,
	});
